import React from 'react';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import Menu from 'material-ui/svg-icons/navigation/menu';
import {DS} from '../theme-default';
import GlobalSearch from '../components/search/GlobalSearch';

class MenuHeader extends React.Component {

    render() {
        const {styles, handleChangeRequestNavDrawer} = this.props;

        const style = {
            appBar: {
                position: 'fixed',
                top: 0,
                left: 0,
                overflow: 'hidden',
                maxHeight: 57,
                backgroundColor: DS.surface,
                borderBottom: `1px solid ${DS.border}`,
                boxShadow: 'none'
            },
            menuButton: {
                marginLeft: 10
            },
            iconsRightContainer: {
                marginLeft: 20
            }
        };

        return (
            <div>
                <AppBar
                    style={{...styles, ...style.appBar}}
                    title={<span className="ds-appbar-title">{this.props.title}</span>}
                    titleStyle={{color: DS.primary, fontSize: 18, fontWeight: 600}}
                    iconElementLeft={
                        <IconButton style={style.menuButton} onClick={handleChangeRequestNavDrawer}>
                            <Menu color={DS.ink}/>
                        </IconButton>
                    }
                />
                {/* rendered outside the AppBar because it clips overflow (maxHeight 57) */}
                <GlobalSearch/>
            </div>
        );
    }
}

export default MenuHeader;
